function observe(element, callback) {
  const observer = new IntersectionObserver(callback);
  observer.observe(element);
  return observer;
}

module.exports = observe;
